require.register("app/Application", function(exports, require, module){
  $0
  
});

